export default ['#ED6A5A', '#247BA0', '#9BC1BC', '#5CA4A9', '#E6EBE0'];
